// extracted by mini-css-extract-plugin
export default {"container":"DivTable_container__MS-m9"};